import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import LineSetList from './LineSetList';
import LineSetEdit from './LineSetEdit';

const LineSetPage = (props) => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/new`}>
                <LineSetEdit {...props} />
            </Route>
            <Route path={`${path}/:id/edit`}>
                <LineSetEdit {...props} />
            </Route>
            <Route exact path={path}>
                <LineSetList {...props} />
            </Route>
        </Switch>
    );
};

export default LineSetPage;
